export var TextFieldTheme = function (theme) { return ({
    defaultProps: {},
    styleOverrides: {},
    variants: [
        {
            props: { multiline: true },
            style: {
                '&:has(.MuiInputBase-multiline)': {
                    '+ .MuiFormHelperText-root': {
                        position: "absolute",
                        right: 0,
                        bottom: 10,
                        color: theme.palette.greySecondary[400],
                    },
                    '&:has(.MuiFormHelperText-root)': {
                        '+ .MuiFormHelperText-root': {
                            position: "absolute",
                            right: 0,
                            bottom: 40,
                        },
                        '&:has(.Mui-error)': {
                            '+ .MuiFormHelperText-root': {
                                position: "absolute",
                                right: 0,
                                bottom: 40,
                                color: theme.palette.error.main,
                            },
                        },
                    },
                },
            },
        },
    ],
}); };
export default TextFieldTheme;
//# sourceMappingURL=theme.js.map